<template>
  <div>
    <section class="service-title-wrap">
      <h4 class="service-title">{{ $t('menuService.commerce') }}</h4>
      <div class="service-title-sub">{{ $t('commerce.headCopy') }}</div>
    </section>

    <section>
      <div class="service-item" :data-id="$t('commerce.bMart.name')">
        <h5 :id="$t('commerce.bMart.name')">{{ $t('commerce.bMart.name') }}</h5>
        <div class="service-item-image">
          <picture>
            <source media="(min-width: 750px)" srcset="~@/static/image/service/pc/bmart@3x.jpg 3x">
            <source media="(max-width: 750px)" srcset="~@/static/image/service/m/bmart@3x.jpg 3x">
            <img src="~@/static/image/service/pc/bmart.jpg" :alt="$t('commerce.bMart.name')">
          </picture>
        </div>
        <div class="service-item-title">
          <img
            src="~@/static/image/logo-family/logo_bmart.png"
            srcset="~@/static/image/logo-family/logo_bmart@2x.png 2x, ~@/static/image/logo-family/logo_bmart@3x.png 3x"
            :alt="$t('commerce.bMart.name')"
          >
          <html-view tag="p" :value="$t('commerce.bMart.title')" />
        </div>
        <div class="service-item-content">
          <html-view :value="$t('commerce.bMart.content')" />
        </div>
      </div>
      <div class="service-item" :data-id="$t('commerce.shoppingLive.name')">
        <h5 :id="$t('commerce.shoppingLive.name')">{{ $t('commerce.shoppingLive.name') }}</h5>
        <div class="service-item-image">
          <picture>
            <source media="(min-width: 750px)" srcset="~@/static/image/service/pc/shopping_live@3x.jpg 3x">
            <source media="(max-width: 750px)" srcset="~@/static/image/service/m/shopping_live@3x.jpg 3x">
            <img src="~@/static/image/service/pc/shopping_live.jpg" :alt="$t('commerce.shoppingLive.name')">
          </picture>
        </div>
        <div class="service-item-title">
          <img
            src="~@/static/image/logo-family/logo_shopping_live.png"
            srcset="~@/static/image/logo-family/logo_shopping_live@2x.png 2x, ~@/static/image/logo-family/logo_shopping_live@3x.png 3x"
            :alt="$t('commerce.shoppingLive.name')"
          >
          <html-view tag="p" :value="$t('commerce.shoppingLive.title')" />
        </div>
        <div class="service-item-content">
          <html-view :value="$t('commerce.shoppingLive.content')" />
        </div>
      </div>
      <div class="service-item" :data-id="$t('commerce.gifts.name')">
        <h5 :id="$t('commerce.gifts.name')">{{ $t('commerce.gifts.name') }}</h5>
        <div class="service-item-image">
          <picture>
            <source media="(min-width: 750px)" srcset="~@/static/image/service/pc/gift@3x.jpg 3x">
            <source media="(max-width: 750px)" srcset="~@/static/image/service/m/gift@3x.jpg 3x">
            <img src="~@/static/image/service/pc/gift.jpg" :alt="$t('commerce.gifts.name')">
          </picture>
        </div>
        <div class="service-item-title">
          <img
            src="~@/static/image/logo-family/logo_gift.png"
            srcset="~@/static/image/logo-family/logo_gift@2x.png 2x, ~@/static/image/logo-family/logo_gift@3x.png 3x"
            :alt="$t('commerce.gifts.name')"
          >
          <html-view tag="p" :value="$t('commerce.gifts.title')" />
        </div>
        <div class="service-item-content">
          <html-view :value="$t('commerce.gifts.content')" />
        </div>
      </div>
      <div class="service-item" :data-id="$t('commerce.delicacies.name')">
        <h5 :id="$t('commerce.delicacies.name')">{{ $t('commerce.delicacies.name') }}</h5>
        <div class="service-item-image">
          <picture>
            <source media="(min-width: 750px)" srcset="~@/static/image/service/pc/taste@3x.jpg 3x">
            <source media="(max-width: 750px)" srcset="~@/static/image/service/m/taste@3x.jpg 3x">
            <img src="~@/static/image/service/pc/taste.jpg" :alt="$t('commerce.delicacies.name')">
          </picture>
        </div>
        <div class="service-item-title">
          <img
            src="~@/static/image/logo-family/logo_taste.png"
            srcset="~@/static/image/logo-family/logo_taste@2x.png 2x, ~@/static/image/logo-family/logo_taste@3x.png 3x"
            :alt="$t('commerce.delicacies.name')"
          >
          <html-view tag="p" :value="$t('commerce.delicacies.title')" />
        </div>
        <div class="service-item-content">
          <html-view :value="$t('commerce.delicacies.content')" />
        </div>
      </div>
    </section>
  </div>
</template>

<script>
export default {
}
</script>
